import React from "react";

const RouterContext = React.createContext("default");

export default RouterContext;
